"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ValidationError_1 = __importDefault(require("../../shared/errors/ValidationError"));
const ValidationErrorCode_1 = __importDefault(require("../../shared/errors/ValidationErrorCode"));
const ValidationIssue_1 = __importDefault(require("../../shared/errors/ValidationIssue"));
class GenericValidator {
    options;
    constructor(options = {}) {
        this.options = options;
    }
    validate(input, modelType, schema) {
        const result = schema.validate(input, {
            abortEarly: false,
            convert: false,
            ...this.options,
        });
        const validationIssueList = this.handleIssues(result, modelType, '$.');
        this.processErrors(validationIssueList);
    }
    handleIssues(result, modelType, rootPath, issueList) {
        let issues = [];
        if (issueList && issueList.length > 0) {
            issues = [...issueList];
        }
        if (!rootPath) {
            rootPath = '$.';
        }
        if (result.error) {
            result.error.details.forEach((issue) => {
                const issueType = issue.type;
                const issuePath = `${rootPath}${issue.path.length > 0 ? issue.path[0].toString() : ''}`;
                switch (issueType) {
                    case 'any.required': {
                        issues.push(new ValidationIssue_1.default(modelType, ValidationErrorCode_1.default.requiredValue, issue.context?.key, issue.context?.value, issuePath, issueType));
                        break;
                    }
                    case 'any.unknown':
                    case 'object.unknown': {
                        issues.push(new ValidationIssue_1.default(modelType, ValidationErrorCode_1.default.notAllowed, issue.context?.key, issue.context?.value, issuePath, issueType));
                        break;
                    }
                    case 'object.base':
                    case 'array.base':
                    case 'boolean.base':
                    case 'number.base':
                    case 'string.base': {
                        issues.push(new ValidationIssue_1.default(modelType, ValidationErrorCode_1.default.invalidType, issue.context?.label ||
                            issue.context?.key, issue.context?.value, issuePath, issueType));
                        break;
                    }
                    case 'any.only':
                    case 'array.min':
                    case 'array.max':
                    case 'number.greater':
                    case 'number.integer':
                    case 'number.less':
                    case 'number.max':
                    case 'number.min':
                    case 'number.negative':
                    case 'number.positive':
                    case 'number.precision':
                    case 'string.alphanum':
                    case 'string.case':
                    case 'string.empty':
                    case 'string.guid':
                    case 'string.length':
                    case 'string.lowercase':
                    case 'string.max':
                    case 'string.min':
                    case 'string.trim':
                    case 'string.uppercase':
                    case 'string.pattern.base': {
                        issues.push(new ValidationIssue_1.default(modelType, ValidationErrorCode_1.default.invalidValue, issue.context?.label ||
                            issue.context?.key, issue.context?.value, issuePath, issueType));
                        break;
                    }
                    case 'array.unique': {
                        issues.push(new ValidationIssue_1.default(modelType, ValidationErrorCode_1.default.notAllowed, issue.context?.label, issue.context?.value, issuePath, issueType));
                        break;
                    }
                    default: {
                        issues.push(new ValidationIssue_1.default(modelType, ValidationErrorCode_1.default.unknownIssueType, issue.context?.label ||
                            issue.context?.key, issue.context?.value, issuePath, issueType));
                    }
                }
            });
        }
        return issues;
    }
    processErrors(validationIssueList) {
        if (validationIssueList && validationIssueList.length > 0) {
            const error = new ValidationError_1.default();
            error.addValidationIssueList(validationIssueList);
            throw error;
        }
    }
}
exports.default = GenericValidator;
